import { render, staticRenderFns } from "./OwnerStaffList.vue?vue&type=template&id=9baf0aea&"
import script from "./OwnerStaffList.vue?vue&type=script&lang=ts&"
export * from "./OwnerStaffList.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerStaffList.vue?vue&type=style&index=0&langs=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports